<script setup lang="ts">
import FastDelivery from './icons/fastDelivery.vue';
import DiamondImage from '../diamondImage.vue';
import {Config} from "@/assets/ts/config";
import {SetWidget} from "@/assets/ts/stepWidget";

const props = defineProps<{
  diamond: any;
}>();

const setWidgetApi = new SetWidget()

const getDiamondLink = () => {
  if (setWidgetApi.getConfSession() !== null) {
    return `${Config.getBaseUrl()}${setWidgetApi.getConfSession()}/diamonds/${props.diamond.link}`
  } else {
    return `${Config.getBaseUrl()}diamonds/${props.diamond.link}`
  }

}

</script>

<template>
  <a
      :href="getDiamondLink()"
      class="relative flex flex-col items-center hover:shadow-lg transition-shadow overflow-hidden group aspect-square"
  >
    <FastDelivery
        v-if="diamond.delivery_time < 2"
        class="absolute top-1 right-1 w-8 h-8 text-brand-main z-10"
    />
    <DiamondImage :diamond="diamond"/>
    <div class="relative bottom-0 left-0 right-0 py-2 text-gray-900 w-full px-0 lg:px-2 text-[10px]">
      <div class="flex  uppercase tracking-[0.2em] text-gray-900 mb-0.5 flex flex-wrap gap-x-1 w-full justify-between">
        <span>{{
            diamond.size.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})
          }} ct.</span>
        <span class="text-gray-900">|</span>
        <span>{{ diamond.type === 'lab' ? 'Labor' : 'Natur' }}</span>
        <span class="text-gray-900">|</span>
        <span>{{ diamond.institute }}</span>
      </div>
      <div class=" flex justify-between items-end w-full items-start">
        <div class="grow">
          <div class="uppercase tracking-[0.2em]  flex flex-wrap gap-x-2">
            <span>{{ diamond.color }}</span>
            <span class="text-gray-900">|</span>
            <span>{{ diamond.clarity }}</span>
            <template v-if="diamond.form === 'BR'">
              <span class="text-gray-900">|</span>
              <span>{{ diamond.cut }}</span>
            </template>
          </div>
        </div>
        <p
            class="w-2/5 text-[14px] text-right font-serif whitespace-nowrap"
            :class="diamond.special ? 'text-red-600' : ''"
        >
          {{ diamond.price.toLocaleString('de-DE') }} €
        </p>
      </div>

    </div>
  </a>
</template>

<style scoped>

.font-serif {
  font-family: "Ivy Mode", serif;
}
</style>